module.exports = __webpack_public_path__ + "img/streamer.dd3af1d4.png";